const hasFeatureAccess = (userProfile, featureName) => {
  if (featureName === 'ai') {
    console.log('userProfile', featureName, userProfile);
  }
  if (
    userProfile !== undefined &&
    userProfile.betaFeatures !== undefined &&
    userProfile.betaFeatures[featureName]
  ) {
    return true;
  }
  return false;
};

const shouldShowPaymentInfo = (
  userProfile,
  settings = {},
  iosIapGloballyEnabled = false
) => {
  return Boolean(
    settings.showPaymentInfo ||
      (settings.isWrapped &&
        (iosIapGloballyEnabled || hasFeatureAccess(userProfile, 'ios_iap')))
  );
};

export default {
  hasFeatureAccess,
  shouldShowPaymentInfo
};
